const copy = {
  "meeting.label": "Meeting your cogent",
  "meeting.waking": "Waking up.",
  "meeting.slow": "Still waking up. You can wait or come back soon.",
  "arena.notNow": "Stay and chat",
  "arena.actionNamed": "Play {coworld} with {name}",
  "arena.subline": "The conversation comes with you.",
  "chat.hello": "Say hello",
  "chat.placeholder": "Say something to {name}",
  "setup.ready": "Getting {name} ready…",
} as const;
type CopyKey = keyof typeof copy;
/** The string for `key`, with `{name}`-style holes filled. */
export function words({
  key,
  values = {},
}: {
  key: CopyKey;
  values?: Record<string, string | number>;
}): string {
  return copy[key].replace(/\{(\w+)\}/g, (hole, k: string) =>
    k in values ? String(values[k]) : hole,
  );
}
